export default {"src":"/_next/static/media/calendarTwo_40.b508701d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};